import { useCallback, useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from "powerbi-client";
import { useData } from '../providers/DataContext';
import { makeStyles } from '@fluentui/react-components';

import { useMsal, useIsAuthenticated } from '@azure/msal-react';

const useStyles = makeStyles({
  root: {
    height: '100%'
  }
});

function PowerBIReport() {
  const {instance: msalInstance, accounts: msalAccounts} = useMsal();
  const [accessToken, setAccessToken] = useState(undefined);
  const [report, setReport] = useState();
  const {setRecipeFull} = useData();
  const isAuthenticated = useIsAuthenticated();
  const styles = useStyles();

  const acquireAccessToken = useCallback(async () => {
    console.info('acquiring access token');

    if (!isAuthenticated) {
      console.info('reinitializing msal app');
      await msalInstance.initialize();
    }
    const powerBiRequest = {
      scopes: [
        "https://analysis.windows.net/powerbi/api/Report.Read.All",
        "https://analysis.windows.net/powerbi/api/Dataset.Read.All"
      ],
      account: msalAccounts[0]
    };
    try {
      console.info('acquiring token silently');
      const response = await msalInstance.acquireTokenSilent(powerBiRequest);
      setAccessToken(response.accessToken);
      return response.accessToken;
    } catch {
      try {
        console.info('failed to acquire token silently, acquiring token with redirect');
        const response = await msalInstance.acquireTokenRedirect(powerBiRequest);
        setAccessToken(response.accessToken);
        return response.accessToken;
      } catch (error) {
        console.error("acquireAccessTokenError: Failed to acquire access token: ", error);
      } finally {
        return null;
      }
    }
  }, [isAuthenticated, msalAccounts, msalInstance]);

  const embedConfig = {
    type: 'report',
    tokenType: models.TokenType.Aad,
    embedUrl: `${process.env.REACT_APP_POWERBI_REPORT_EMBED_URL}&language=fr&formatlocale=fr-CA`,
    id: process.env.REACT_APP_POWERBI_REPORT_ID,
    settings: {
      filterPaneEnabled: false,
      navContentPaneEnabled: false
    },
    eventHooks: {
      accessTokenProvider: acquireAccessToken  // https://learn.microsoft.com/en-us/javascript/api/overview/powerbi/refresh-token
    }
  };

  useEffect(() => {
    acquireAccessToken().then(() => {
      console.log("Access token acquired.");
    });
  }, [acquireAccessToken]);

  useEffect(() => {
    if (report) {
      console.log('Report object set', report);
    }
  }, [report]);

  return (
    <PowerBIEmbed
      embedConfig={{
        ...embedConfig,
        accessToken
      }}
      eventHandlers={new Map([
        ['dataSelected', function (event) {
          console.log(event)
          if (event.detail.visual.name === 'aed336f5012e4274c35e') {
            setRecipeFull(event.detail.dataPoints[0].identity[0].equals);
            console.log(event.detail.dataPoints[0].identity[0].equals);
          }
        }]
      ])}
      cssClassName={styles.root}
      getEmbeddedComponent={(embeddedReport) => {
        setReport(embeddedReport);
        console.log('Report embedded:', embeddedReport);
        document.querySelector("iframe").style.boxSizing = "border-box";
      }}
    />
  );
}

export default PowerBIReport;
